import { request } from '@/common/services/request';
import { validateCreationEntry } from '../utils/harness-creation';

export async function createAgentChatThread({ organizationId, entry }) {
  const result = await request('/api/agents/chat/threads', {
    method: 'POST',
    params: { organizationId },
    data: { mode: 'harness', ...(entry == null ? {} : { entry: validateCreationEntry(entry) }) },
  });
  return result.data;
}

export async function queryAgentChatThread({ organizationId, threadId }) {
  const result = await request('/api/agents/chat/threads', {
    method: 'GET',
    params: { organizationId, threadId },
  });
  return result.data;
}

export const getAgentsChatApi = (organizationId, threadId) => {
  const apiBase = (process.env.VITE_API_BASE || '').replace(/\/$/, '');
  const params = new URLSearchParams({ organizationId });
  if (threadId) {
    params.set('threadId', threadId);
  }

  return `${apiBase}/api/agents/chat?${params.toString()}`;
};

export async function queryAvailableAgents(params) {
  const result = await request('/api/agents/available', {
    method: 'GET',
    params,
  });
  return result.data || [];
}

export async function queryAgentChatThreads(params = {}) {
  const result = await request('/api/agents/chat/threads', {
    method: 'GET',
    params: {
      current: params.current || 1,
      end: params.end,
      organizationId: params.organizationId,
      pageSize: params.pageSize || 20,
      start: params.start,
      title: params.title,
    },
  });
  return {
    data: result.data || [],
    meta: result.meta || {},
  };
}

export async function removeAgentChatThread(params = {}) {
  const result = await request('/api/agents/chat/threads', {
    method: 'DELETE',
    params: {
      organizationId: params.organizationId,
      threadId: params.threadId,
    },
  });
  return result.data || {};
}

export async function queryAgentChatMessages(params = {}) {
  const result = await request('/api/agents/chat/messages', {
    method: 'GET',
    params: {
      organizationId: params.organizationId,
      threadId: params.threadId,
    },
  });
  return result.data || [];
}

export async function queryAgentChatResult(params = {}) {
  const result = await request('/api/agents/chat/result', {
    method: 'GET',
    params: {
      organizationId: params.organizationId,
      threadId: params.threadId,
    },
  });
  return result.data || {};
}

export async function queryAgentChatEntryThread(params = {}) {
  const result = await request('/api/agents/chat/entry-thread', {
    method: 'GET',
    params: {
      entry: params.entry,
      organizationId: params.organizationId,
      recordId: params.recordId,
    },
  });
  return {
    threadId: result.data?.threadId || null,
  };
}

export async function queryMainAgentEntries(params) {
  const result = await request('/api/agents/chat/entries', {
    method: 'GET',
    params: {
      organizationId: params?.organizationId,
    },
  });
  return {
    hotPots: result.data?.hotPots || [],
    seedPlans: result.data?.seedPlans || [],
  };
}
